// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3-VEO","footer":"ModalError_footer__VoF3I"};